'use client';

import Link from 'next/link';
import { ArrowRightIcon } from 'lucide-react';

import PublicPageLayout from '@/components/layouts/PublicPageLayout';
import { copy } from '@/data/copy';
import { Button } from '@/components/ui/button';

export default function Homepage() {
  return (
    <PublicPageLayout
      CTAContent={
        <>
          <h1 className="text-bodydark1">{copy.pages.root.welcome}</h1>
          <p className="text-bodydark1 mt-8">
            {copy.common.publicRoute.whoWeAre}
          </p>
        </>
      }
    >
      <div className="flex justify-center">
        <div className="flex w-full md:w-md lg:w-xl flex-col gap-4">
          <div className="flex gap-4 flex-col lg:flex-row justify-center">
            <Link href="/signup" className="w-full">
              <Button size="lg" className="w-full h-16">
                {copy.pages.root.createAnAccountAsMentee}
              </Button>
            </Link>

            <Link href="/signup/mentor" className="w-full">
              <Button size="lg" className="w-full h-16">
                {copy.pages.root.createAnAccountAsMentor}
              </Button>
            </Link>
          </div>

          <Link href="/signin" className="w-full h-10" target="_blank">
            <Button size="lg" className="w-full">
              {copy.pages.root.login} <ArrowRightIcon />
            </Button>
          </Link>
        </div>
      </div>
      <p className="mt-4 text-center text-sm">
        {copy.common.form.lostYourPassword}{' '}
        <Link href="/reset-password" className="cta-link">
          {copy.common.form.resetPassword}
        </Link>
      </p>
    </PublicPageLayout>
  );
}
